export const emailPromptPrefix = 'email-propmpt';
export const getEmailPromptId = (elementId) => `${emailPromptPrefix}-${elementId}`;
